import React, {useEffect} from 'react'
import {observer} from 'mobx-react-lite'
import {TObservablePage} from '../../types/commerce'
import {Box, Text, Flex} from '../../vanilla'

import {usePageDataTracking} from '../../analytics/page-tracking'
import {ResetAndContinueShoppingButtons} from '../../components/reset-and-continue-shopping-buttons'
import {Layout} from '../../components/layout'
import {Seo} from '../../components/seo'
import {
  resetShoppingContainer,
  resetShoppingParentContainer,
  resetShoppingTitle,
  resetShoppingTextContainer,
  bulletPointText,
  resetShoppingSubTitle
} from './styles.css'

const ResetAndContinueShoppingPage: TObservablePage = observer(() => {
  const sendPageData = usePageDataTracking()
  const pageType = 'reset-and-continue-shopping'
  const pageCategory = 'Reset and Continue Shopping'
  useEffect(() => {
    sendPageData(pageType, pageCategory)
  }, [])

  return (
    <Layout>
      <Seo title="Reset & Continue Shopping" description="Reset & Continue Shopping" />
      <Flex className={resetShoppingParentContainer}>
        {/* Reset Shopping container and title */}
        <Box className={resetShoppingContainer}>
          <Text
            variant="heading1"
            className={resetShoppingTitle}
          >
            Reset & Continue Shopping
          </Text>
          {/* Main text container */}
          <Flex className={resetShoppingTextContainer}>
            <Box>
              <Text variant="text4">
                If you’re having trouble browsing our site, this tool can help by clearing your
                session and cookie data to give you a fresh start.
              </Text>
            </Box>
            <Flex direction="column" gap="16px">
              <Text
                variant="text7"
                className={resetShoppingSubTitle}
              >
                What happens when you reset your session?
              </Text>
              <Text as="li" variant="text4" lineHeight="shorter" className={bulletPointText}>
                You will be logged out of your Iceland account.
              </Text>
              <Text as="li" variant="text4" lineHeight="shorter" className={bulletPointText}>
                This page will refresh and you will see our homepage.
              </Text>
              <Text as="li" variant="text4" lineHeight="shorter" className={bulletPointText}>
                You will need to log back into your Iceland account.
              </Text>
            </Flex>
            <Text variant='text5'>
              Don’t worry, if you’re logged in already, any items in your basket will remain saved and you can continue shopping after logging in again.
            </Text>
          </Flex>
        </Box>
        {/* Button container */}
        <Box width="full">
          <ResetAndContinueShoppingButtons />
        </Box>
      </Flex>
    </Layout>
  )
})

export default ResetAndContinueShoppingPage
